import {ZIDX, ZIDXPage} from "../../standalone/standaloneLibrary.js";

export class ZIDXAccountCMAReportsEdit implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountCMAReportsEditContainer";
    }
    render(){
        // console.log("edit cma-reports");
    }
}